/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - Portfolio
 * Date: 5/17/21
 * Copyright All Rights Reserved
 */
import { keyBy } from 'lodash/fp';

const occupancies = [
  { occupancyId: 1, occupancy: 'Commercial Office' },
  { occupancyId: 2, occupancy: 'Education [k-12]: Elementary Schools' },
  { occupancyId: 3, occupancy: 'Education [k-12]: Middle Schools' },
  { occupancyId: 4, occupancy: 'Education [k-12]: High Schools' },
  { occupancyId: 5, occupancy: 'Healthcare' },
  { occupancyId: 6, occupancy: 'Hospitality' },
  { occupancyId: 7, occupancy: 'Multi-Unit Residential' },
  { occupancyId: 8, occupancy: 'Research' },
  { occupancyId: 9, occupancy: 'Retail' },
  { occupancyId: 10, occupancy: 'Warehouse' },
  { occupancyId: 11, occupancy: 'Single-Unit Residential' },
];

const occupancyById = keyBy('occupancyId', occupancies);

const getOccupancyDescription = occupancyId => occupancyById[occupancyId].occupancy;

export default getOccupancyDescription;



// WEBPACK FOOTER //
// ./js/support/getOccupancyDescription.js